import React from 'react'
import tw, { styled, css } from "twin.macro"
import classNames from "classnames";

interface Props {
  autoHeightResponsive?: boolean
  autoHeight?: boolean
  anchor?: string
  photo_icon?: string
}

const SlideSection: React.SFC<Props> = ({ children, autoHeightResponsive, autoHeight, anchor, photo_icon, }) => 
  <div data-anchor={anchor} className={ classNames('section', {
    'fp-auto-height': autoHeight,
    'fp-auto-height-responsive': autoHeightResponsive
  })}
  style={{backgroundImage: 'url(' + require('../images/backgroundIcons.png') + ')',
    backgroundRepeat: `no-repeat`,
    backgroundSize: `cover`,
    backgroundPosition: `center`,
  }}>
    <div css={[css`@media(max-width: 768px){
      padding: 6rem 4rem;
    }`,tw`py-16`]}>
      {children}
    </div>
  </div>


export default SlideSection;
